<div class="modal-header">
    <h4 class="modal-title">Payment Support</h4>
    <button type="button" class="btn btn-danger" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <i class="fas fa-times"></i>
    </button>
</div>
<div class="modal-body">
    <p>
        We are here to help at any stage of the payment process. Let's get started by narrowing down your issue from the
        categories below.
    </p>
    <ngb-accordion [closeOthers]="true" (panelChange)="accordion()">
        <ngb-panel id="static-1" title="My payment is getting declined">
            <ng-template ngbPanelContent>
                First, check to make sure that you are entering your payment information correctly and all applicable
                accounts are valid, funded and non-expired. Second, if possible try an alternative payment method. If
                you would like more information on why you're unable to complete the purchase, please contact us.
            </ng-template>
        </ngb-panel>
        <ngb-panel id="static-2" title="I paid but I haven't got any benefits">
            <ng-template ngbPanelContent>
                Sorry about that! Our security team may have flagged your purchase for a manual review. If you have not
                received your account benefits within 24 hours and you haven't heard from our team, please contact us
                and include the transaction number (if available).
            </ng-template>
        </ngb-panel>
        <ngb-panel id="static-3" title="Is this tax deductible?">
            <ng-template ngbPanelContent>
                NitroPay is not responsible for any taxation recommendations, nor do we handle any payments to the
                appropriate tax entities. Please consult a licensed accountant in your area for tax advice.
            </ng-template>
        </ngb-panel>
        <ngb-panel id="static-4" title="How can I cancel my subscription?">
            <ng-template ngbPanelContent>
                You can cancel at any time by launching NitroPay Sponsor from our partner's website. Please contact us
                if you are having trouble cancelling your subscription and we'll be happy to assist you.
            </ng-template>
        </ngb-panel>
        <ngb-panel id="static-5" title="Can I get a refund?">
            <ng-template ngbPanelContent>
                All sales are final and refunds are not offered per our <a routerLink="/terms">Terms of Use</a>.
            </ng-template>
        </ngb-panel>
        <ngb-panel id="static-6" title="I want to speak to someone">
            <ng-template ngbPanelContent>
                <a href="javascript:;" (click)="showIntercom()">Click here</a> to contact a NitroPay representative.
            </ng-template>
        </ngb-panel>
    </ngb-accordion>
</div>
